import { render, staticRenderFns } from "./ques3.vue?vue&type=template&id=206c7fa8"
import script from "./ques3.vue?vue&type=script&lang=js"
export * from "./ques3.vue?vue&type=script&lang=js"
import style0 from "./ques3.vue?vue&type=style&index=0&id=206c7fa8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports